<template>
<div class="chapter">
<div class="inner_page">
<p><a id="epi"></a></p>
<div class="epiv">“With love and care the spiderweb weaves its spider.”</div>
<div class="eps">—UNKNOWN AFRICAN ORIGIN</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595586124_oeb_epi_r1.vue?4142644c